import React from 'react';
import { Loader, AlertCircle } from 'lucide-react';
import ChatMessage from './ChatMessage';

const ChatArea = ({ 
  currentConversation,
  editingMessageId,
  editingContent,
  setEditingContent,
  editMessage,
  cancelEditMessage,
  isLoading,
  startEditMessage,
  rollbackToMessage,
  copyMessage,
  copiedMessageId,
  apiError,
  showApiKeyModal,
  openApiKeyModal,
  messagesEndRef 
}) => {
  if (!currentConversation) {
    return (
      <div className="chat-area">
        <div className="no-conversation">
          会話を選択してください
        </div>
      </div>
    );
  }

  return (
    <div className="chat-area">
      <div className="messages-container">
        {currentConversation.messages.map((message, index) => (
          <ChatMessage
            key={message.id}
            message={message}
            index={index}
            editingMessageId={editingMessageId}
            editingContent={editingContent}
            setEditingContent={setEditingContent}
            editMessage={editMessage}
            cancelEditMessage={cancelEditMessage}
            isLoading={isLoading}
            startEditMessage={startEditMessage}
            rollbackToMessage={rollbackToMessage}
            copyMessage={copyMessage}
            copiedMessageId={copiedMessageId}
          />
        ))}
        
        {isLoading && (
          <div className="message message-assistant">
            <div className="loading">
              <Loader className="icon-small spinning" />
              <span>考え中...</span>
            </div>
          </div>
        )}
        
        {apiError && !showApiKeyModal && (
          <div className="error-container">
            <AlertCircle className="icon-small" />
            <div>
              <p>{apiError}</p>
              <button onClick={openApiKeyModal} className="link">
                APIキーを設定する
              </button>
            </div>
          </div>
        )}
        
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default ChatArea;